import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('ChecklistState')
export class ChecklistState {
  public static create(checklistState: ChecklistState) {
    return Object.assign(new ChecklistState(), checklistState);
  }
  public static createNew(itemStates: boolean[][], workflowId: number) {
    return Object.assign(new ChecklistState(), {
      itemStates,
      workflowId,
    });
  }
  @JsonProperty('itemStates', [[Boolean]])
  // @ts-expect-error TS2322 - strict migration
  itemStates: boolean[][] = undefined;
  @JsonProperty('workflowId', Number)
  // @ts-expect-error TS2322 - strict migration
  workflowId: number = undefined;
}
